import { Stack, Typography } from "@mui/material";

interface DisclaimerMessageProps {
  header: string;
  content?: string;
}
const DisclaimerMessage = ({ header, content }: DisclaimerMessageProps) => {
  return (
    <Stack gap={2}>
      <Typography variant="h5" fontWeight={700}>
        {header}
      </Typography>
      <Typography variant="subtitle1">{content}</Typography>
    </Stack>
  );
};

export default DisclaimerMessage;
